import { LoadableAfterPaint } from '@confluence/loadable';

export const WidgetMacroHandler = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-WidgetMacro" */ '../src/WidgetMacroRenderer.tsx'))
			.WidgetMacroRenderer,
});

export type { WidgetMacroRendererProps } from '../src/WidgetMacroRenderer.tsx';
